import { render, staticRenderFns } from "./TradeRef.vue?vue&type=template&id=097e7c3e"
import script from "./TradeRef.vue?vue&type=script&lang=js"
export * from "./TradeRef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports